import {toEither} from 'Core/models/Async';
import * as A from 'fp-ts/lib/Array';
import * as E from 'fp-ts/lib/Either';
import {identity} from 'fp-ts/lib/function';
import {IO, map as mapIO} from 'fp-ts/lib/IO';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import {doNothing, NoOp} from 'Shared/utilities/IOUtilities';
import {getIsNewYorkFromAgency} from 'Shared/utilities/isNewYorkUtility';
import {fromLocalStorage, LocalStorageKey} from 'Shared/utilities/localStorage';
import {safeParseJson} from 'Shared/utilities/parsers';
import {setSelectedAgency} from 'Users/ducks/userProfile';
import {AgentClaims} from 'Users/models/AgentClaims';
import {AsyncUserClaims, UserClaims, UserTypeClaimKey, UserTypeClaims} from 'Users/models/Claims';

export const selectFirstAgencyAsDefault = (agentClaims: AgentClaims, setAgency: typeof setSelectedAgency) => () => {
  const defaultAgency = pipe(agentClaims.agencyAssociations, A.head);
  const isNewYork = getIsNewYorkFromAgency(defaultAgency);

  setAgency(defaultAgency, isNewYork);
};

export const initializeUser = (userClaims: AsyncUserClaims, setAgency: typeof setSelectedAgency): IO<void> =>
  pipe(
    userClaims,
    toEither,
    E.fold(doNothing, claims => () => {
      claims.userTypes.map(
        UserTypeClaims.match({
          [UserTypeClaimKey.AgentSite]: agentClaims => {
            selectFirstAgencyAsDefault(agentClaims, setAgency)();
          },
          default: NoOp,
        })
      );
    })
  );

export const parseUserClaims = identity;

export const getUserClaims = pipe(
  fromLocalStorage(LocalStorageKey.Claims),
  mapIO(O.fromNullable),
  mapIO(claimOption => pipe(claimOption, O.chain(safeParseJson<UserClaims>()), O.map(parseUserClaims)))
);
